import { VerticalLeftOutlined } from "@ant-design/icons";
import { Button, Form, Input } from "antd";
import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axiosInstance from "../common/api";

export default function () {
    const { id } = useParams();
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const onFinish = (form) => {
        setLoading(true);
        axiosInstance
            .post(`/fine/${id}/toManage`, form)
            .then(() => navigate(-1))
            .finally(() => setLoading(false));
    };

    return (
        <Form onFinish={onFinish} layout="vertical">
            <Form.Item label="Commento" name="comment">
                <Input.TextArea />
            </Form.Item>
            <Form.Item style={{ textAlign: "end" }}>
                <Button htmlType="submit" type="primary" loading={loading}>
                    Conferma
                </Button>
            </Form.Item>
        </Form>
    );
}
